<script>
  import { Input, Radio, Select, Switch, Badge, Breadcrumb } from "spaper";
  import Icon from "svelte-awesome";
  import { upload } from "svelte-awesome/icons";
  import { strings } from "../constants/strings";
  import { registerAdoptable } from "../utils/utils";
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";

  // Form data
  let name = "";
  let sex = "female";
  let kind = "cat";
  let ageMonths;
  let ageYears;
  let temper = "calm";
  let size = "small";
  let description = "";
  let color = "beige";
  let sterilized = false;
  let likesChildren = false;
  let likesOtherPets = false;
  let published = true;

  let imgSrc = "images/new_dog.png";
  let imgStatus = 0;
  let formError = "";
  let formStatus = 0;
  $: imgText = strings.formMessages.imageLifecycle[imgStatus];

  const breadcrumbPath = [
    {
      text: "Administrador",
      href: "/_admin",
    },
    {
      text: "Nuevo Adoptable",
      href: "/_newadoptable",
    },
  ];

  const resetForm = () => {
    name = "";
    sex = "female";
    kind = "cat";
    ageMonths = "";
    ageYears = "";
    temper = "calm";
    size = "small";
    description = "";
    color = "beige";
    sterilized = false;
    likesChildren = false;
    likesOtherPets = false;
    published = true;
    imgSrc = "images/cat_dog_icon.png";
    imgStatus = 0;
    imgText = strings.formMessages.imageLifecycle[imgStatus];
    formStatus = 0; // Stand-by
    formError = "";
  };

  const updateImage = () => {
    const input = document.querySelector("#adoptable-pic-input");
    let reader = new FileReader();
    reader.onload = (i) => {
      imgSrc = i.target.result;
      imgStatus = 2;
    };
    reader.readAsDataURL(input.files[0]);
    imgStatus = 1;
  };

  const validateForm = () => {
    if (name == "") {
      formError = strings.formMessages.validation.allFieldsRequired;
      return false;
    }
    if (isNaN(parseInt(ageMonths)) || isNaN(parseInt(ageYears))) {
      formError = strings.formMessages.validation.allFieldsRequired;
      return false;
    }
    if (parseInt(ageYears) < 0 || parseInt(ageYears) > 20) {
      formError = strings.formMessages.validation.invalidAge;
      return false;
    }
    if (parseInt(ageMonths) < 0 || parseInt(ageMonths) >= 12) {
      formError = strings.formMessages.validation.invalidAge;
      return false;
    }
    if (parseInt(ageMonths) == 0 && parseInt(ageYears) == 0) {
      formError = strings.formMessages.validation.invalidAge;
      return false;
    }
    if (!imgStatus) {
      formError = strings.formMessages.validation.missingPicture;
      return false;
    }
    if (description == "") {
      formError = strings.formMessages.validation.allFieldsRequired;
      return false;
    }
    formError = "";
    return true;
  };

  const getFormData = () => {
    let formData = new FormData();
    const input = document.querySelector("#adoptable-pic-input");
    formData.append("name", name);
    formData.append("kind", kind);
    formData.append("sex", sex);
    formData.append("ageYears", ageYears);
    formData.append("ageMonths", ageMonths);
    formData.append("temper", temper);
    formData.append("size", size);
    formData.append("description", description);
    formData.append("color", color);
    formData.append("sterilized", sterilized);
    formData.append("likesChildren", likesChildren);
    formData.append("likesOtherPets", likesOtherPets);
    formData.append("published", published);
    formData.append("picture", input.files[0]);
    return formData;
  };

  const submitForm = async () => {
    if (!validateForm()) return;
    formStatus = 1; // Submitting
    const data = getFormData();
    try {
      await registerAdoptable(data);
      formStatus = 2; // Submited
      setTimeout(resetForm, 2500);
    } catch (errorMessage) {
      resetForm();
      formError = errorMessage;
    }
  };
</script>

<HeaderMini />
<Breadcrumb items={breadcrumbPath} />
<div class="form-group">
  <img src={imgSrc} alt="Adoptable" width="180" />
  <br />
  <br />
  <input
    type="file"
    id="adoptable-pic-input"
    name="picture"
    class="pic-picker"
    on:change={updateImage}
  />
  <label for="adoptable-pic-input" class="paper-btn">
    <Icon data={upload} />
    &nbsp;&nbsp;{imgText}
  </label>
  <p>Nombre</p>
  <Input bind:value={name} />
  <br />
  <p>Especie</p>
  <Radio value="cat" label="Gato" bind:group={kind} />
  <Radio value="dog" label="Perro" bind:group={kind} />
  <br />
  <p>Sexo</p>
  <Radio value="female" label="Hembra" bind:group={sex} />
  <Radio value="male" label="Macho" bind:group={sex} />
  <br />
  <p>Edad</p>

  <Input
    type="number"
    id="inputAgeYears"
    placeholder="Años"
    bind:value={ageYears}
  />

  <Input type="number" placeholder="Meses" bind:value={ageMonths} />
  <br />
  <Select label="Temperamento" bind:value={temper}>
    {#each Object.keys(strings.adoptableProps.temper) as tmpr}
      <option value={tmpr}>{strings.adoptableProps.temper[tmpr]}</option>
    {/each}
  </Select>
  {#if kind == "dog"}
    <Select label="Tamaño" bind:value={size}>
      {#each Object.keys(strings.adoptableProps.size) as sz}
        <option value={sz}>{strings.adoptableProps.size[sz]}</option>
      {/each}
    </Select>
  {/if}
  <Select label="Color" bind:value={color}>
    {#each Object.keys(strings.adoptableProps.color) as clr}
      <option value={clr}>{strings.adoptableProps.color[clr]}</option>
    {/each}
  </Select>
  <br />
  <br />
  <Switch bind:checked={sterilized}
    >Esterilizado: {sterilized ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={likesChildren}
    >Convive con niños: {likesChildren ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={likesOtherPets}
    >Convive con otras mascotas: {likesOtherPets ? "Sí" : "No"}</Switch
  >
  <br />
  <br />
  <Switch bind:checked={published}>Publicado: {published ? "Sí" : "No"}</Switch>
  <br />
  <p>Descripción</p>
  <Input type="textarea" bind:value={description} />
  <br />
  {#if formError != ""}
    <Badge type="danger">{formError}</Badge>
    <br />
    <br />
  {/if}
  {#if formStatus == 0}
    <button class="btn-secondary" on:click={submitForm}>Registrar</button>
  {:else if formStatus == 1}
    <Badge type="secondary">Registrando...</Badge>
  {:else if formStatus == 2}
    <Badge type="success">¡Registrado!</Badge>
  {/if}
</div>
<Footer />

<style>
  .form-group {
    margin-left: 10%;
  }
  .pic-picker {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
</style>
